
import logo from './assets/logo.svg'
import { SelectClub } from './extra/Components';

const ManualHeader = ({ hideSidebar, setHideSidebar,  club, setClub,}) => (<header className="header fixed-top">
    <div className="branding docs-branding">
        <div className="container-fluid position-relative py-2">
            <div className="docs-logo-wrapper">
                <button id="docs-sidebar-toggler" className="docs-sidebar-toggler docs-sidebar-visible mr-2 d-xl-none"
                    onClick={() => {
                        setHideSidebar(!hideSidebar);
                    }}
                    type="button">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <div className="site-logo"><a className="navbar-brand" href="index.html"><img className="logo-icon mr-2"
                    src={logo} alt="logo" style={{ width: '40px', height: '40px' }} /><span
                        className="logo-text">Fallskärms<span className="text-alt">hoppning</span></span></a></div>
            </div>
            <div className="docs-top-utilities d-flex justify-content-end align-items-center">
                <div className="top-search-box d-none d-lg-flex" style={{ visibility: 'hidden' }}>
                    <form className="search-form">
                        <input type="text" placeholder="Search the docs..." name="search"
                            className="form-control search-input" />
                        <button type="submit" className="btn search-btn" value="Search"><i
                            className="fas fa-search"></i></button>
                    </form>
                </div>
                <span className="d-none d-lg-flex">Klubb:</span> <SelectClub className="form-select form-select-lg mx-md-3 mx-lg-5 mb-0 d-none d-lg-flex"  club={club} setClub={setClub} />
            </div>
        </div>
    </div>
</header>);

export default ManualHeader;